var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33073 19.1989V17.3885H9.16406V6.36556H7.33073V4.53223H9.16406C9.66823 4.53223 10.0998 4.71174 10.4589 5.07077C10.8179 5.4298 10.9974 5.86139 10.9974 6.36556V17.3656C10.9974 17.8697 10.8179 18.3013 10.4589 18.6604C10.0998 19.0194 9.66823 19.1989 9.16406 19.1989H7.33073ZM14.6641 19.1989C14.1599 19.1989 13.7283 19.0194 13.3693 18.6604C13.0102 18.3013 12.8307 17.8697 12.8307 17.3656V6.36556C12.8307 5.86139 13.0102 5.4298 13.3693 5.07077C13.7283 4.71174 14.1599 4.53223 14.6641 4.53223H19.2474C19.7516 4.53223 20.1832 4.71174 20.5422 5.07077C20.9012 5.4298 21.0807 5.86139 21.0807 6.36556V17.3656C21.0807 17.8697 20.9012 18.3013 20.5422 18.6604C20.1832 19.0194 19.7516 19.1989 19.2474 19.1989H14.6641ZM14.6641 17.3885H19.2474V6.36556H14.6641V17.3885ZM4.58073 15.5322L3.27448 14.2489L4.71823 12.7822H0.914062V10.9489H4.71823L3.27448 9.50514L4.58073 8.19889L8.2474 11.8656L4.58073 15.5322Z",
    fill: "#ffffff",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundWhite);
export default __webpack_public_path__ + "static/media/round-white.09c506074c95783079c0a43911245c98.svg";
export { ForwardRef as ReactComponent };